/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Credentials_InvalidInputs */



/**
* | output |
* | --- |
* | "The connector did not return a usable change. Nothing was saved." |
*
* @param {Spaces_Credentials_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_credentials_invalid = /** @type {((inputs?: Spaces_Credentials_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Credentials_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Connector hat keine verwendbare Änderung zurückgegeben. Es wurde nichts gespeichert.")
	return /** @type {LocalizedString} */ ("The connector did not return a usable change. Nothing was saved.")
});